import { Navigate, useLocation } from "react-router-dom";

export default function PersonEventsPage() {
  const location = useLocation();
  return <Navigate to={`${location.pathname}/registrations`} replace />;
}
